import { RouteType } from "types/RouteType";
import portainerConnectionsRoute from "./PortainerConnections/portainerConnections.Route";
import registryConnectionsRoute from "./RegistryConnections/registryConnections.Route";
import registryImagesRoute from "./RegistryImages/registryImages.Route";
import dockerHostsRoute from "./DockerHosts/dockerHosts.Route";
import clientInstancesRoute from "./ClientInstances/clientInstances.Route";
import internalContainersRoute from "./InternalContainers/internalContainers.Route";
import instanceDetailRoute from "./InstanceDetail/instanceDetail.Route";
import deploymentStatusRoute from "./DeploymentStatus/deploymentStatus.Route";

const infrastructureRoutesList: RouteType[] = [
  ...portainerConnectionsRoute,
  // Azure Container Registry connection registry (staff-read, admin-write).
  ...registryConnectionsRoute,
  // Read-only ACR image catalog: repositories + tags for a selected registry.
  ...registryImagesRoute,
  ...dockerHostsRoute,
  ...clientInstancesRoute,
  // IntraSync's own containers (operator-designated internal), managed apart
  // from the client fleet.
  ...internalContainersRoute,
  // Hidden parameterized console route (logs / stats / exec) for one instance.
  ...instanceDetailRoute,
  // Deployment Drift & Go-Live Readiness — read-only drift view.
  ...deploymentStatusRoute,
];

export default infrastructureRoutesList;
